// Company proof for the shared current activity quiz. Same-origin lookup; no form submission.
function track(event, extra) {
  if (window.gtag) window.gtag('event', event, extra || {});
}

export default function initCompanyProof() {
  const email = document.getElementById('hq-email');
  const field = email && email.closest('.reco-hq__field--email');
  if (!email || !field || field.dataset.proofBound) return;
  field.dataset.proofBound = '1';
  const clearBindingFlag = () => { delete field.dataset.proofBound; };
  document.addEventListener('turbo:before-cache', clearBindingFlag);
  document.addEventListener('turbolinks:before-cache', clearBindingFlag);

  let lastDomain = null;
  let debounce = null;

  function proofLine() {
    let line = field.querySelector('.reco-hq__proof');
    if (!line) {
      line = document.createElement('p');
      line.className = 'reco-hq__proof';
      const hint = field.querySelector('.reco-hq__hint');
      hint ? field.insertBefore(line, hint) : field.appendChild(line);
    }
    return line;
  }

  function render(data) {
    const existing = field.querySelector('.reco-hq__proof');
    if (!data || !data.found || (!data.bookings && !data.reviews)) {
      if (existing) existing.remove();
      return;
    }
    const line = proofLine();
    line.textContent = '';
    const strong = document.createElement('b');
    if (data.bookings > 0) {
      strong.textContent = `${data.bookings.toLocaleString()} booking${data.bookings === 1 ? '' : 's'}`;
      line.append('✓ ', strong, ` from teams at ${data.company} — your matches will show what they loved.`);
    } else {
      strong.textContent = data.company;
      line.append('✓ Colleagues at ', strong, ' have reviewed activities here.');
    }
    track('personalization_shown', { feature: 'company_proof' });
  }

  function lookup() {
    const value = email.value.trim().toLowerCase();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(value)) return;
    const domain = value.split('@')[1];
    if (domain === lastDomain) return;
    lastDomain = domain;

    fetch('/recommendations/company_proof', {
      method: 'POST',
      body: new URLSearchParams({ email: value })
    })
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        // Stale response for a domain they've since edited away from: drop it.
        if (email.value.trim().toLowerCase().split('@')[1] === domain) render(data);
      })
      .catch(() => {});
  }

  email.addEventListener('input', () => {
    clearTimeout(debounce);
    debounce = setTimeout(lookup, 700);
  });
  email.addEventListener('blur', lookup);
  // A restored resume email or signed-in prefill is already sitting in the
  // field — show them their company's proof without requiring a keystroke.
  if (email.value) lookup();
}

